// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"2589fd1d","513":"b4c4f6e2","703":"14e63782","787":"dc765cd8"}[chunkId] + ".chunk.js";
};